import React from 'react';
import { Copy, Download, Check, RefreshCw, Loader2, FileText } from 'lucide-react';
import { Button } from '@/components/ui/Button';

interface LetterHeaderProps {
  onRetry?: () => void;
  handleCopy: () => void;
  copied: boolean;
  handleExportPDF: () => void;
  isDownloading: boolean;
}

export const CoverLetterHeader = ({
  onRetry,
  handleCopy,
  copied,
  handleExportPDF,
  isDownloading
}: LetterHeaderProps) => {
  return (
    <div className="flex items-center justify-between px-4 lg:px-8 py-4 lg:py-5 border-b border-slate-300 dark:border-slate-800 bg-white dark:bg-slate-900 z-10 flex-col sm:flex-row gap-4 sm:gap-2 rounded-t-xl shrink-0">
      <div className="flex items-center gap-2 text-slate-900 dark:text-white">
        <FileText className="w-5 h-5 text-emerald-600 dark:text-emerald-500" />
        <h2 className="text-sm font-semibold tracking-tight w-full sm:w-auto text-center sm:text-left">Your Cover Letter</h2>
      </div>
      <div className="flex items-center justify-center sm:justify-end gap-2 w-full sm:w-auto flex-wrap">
        {onRetry && (
          <Button
            variant="ghost"
            onClick={onRetry}
            className="flex-1 sm:flex-none h-auto py-1.5 px-3 min-h-[36px]"
          >
            <RefreshCw className="w-4 h-4 shrink-0" />
            <span className="whitespace-nowrap ml-1.5 inline">Retry</span>
          </Button>
        )}
        <button
          onClick={handleCopy}
          className="flex-1 sm:flex-none flex items-center justify-center gap-1.5 px-3 py-1.5 bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-200 text-sm font-medium rounded-lg hover:bg-slate-200 dark:hover:bg-slate-700 transition-all cursor-pointer min-h-[36px]"
        >
          {copied ? <Check className="w-4 h-4 text-emerald-500 shrink-0" /> : <Copy className="w-4 h-4 shrink-0" />}
          <span className="whitespace-nowrap inline">Copy</span>
        </button>
        <Button
          variant="primary"
          onClick={handleExportPDF}
          disabled={isDownloading}
          className="flex-1 sm:flex-none h-auto py-1.5 px-3 min-h-[36px]"
        >
          {isDownloading ? <Loader2 className="w-4 h-4 animate-spin shrink-0" /> : <Download className="w-4 h-4 shrink-0" />}
          <span className="whitespace-nowrap ml-1.5 inline">{isDownloading ? 'Generating...' : 'Export PDF'}</span>
        </Button>
      </div>
    </div>
  );
};
